import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "icon"]
  static values = { target: String, loaded: Boolean }

  // For existing inline expandable rows (immediate toggle)
  toggle() {
    const targetRow = document.getElementById(this.targetValue)
    const isHidden = targetRow.classList.contains('hidden')
    
    if (isHidden) {
      targetRow.classList.remove('hidden')
      this.textTarget.textContent = "Hide Details"
      this.iconTarget.style.transform = "rotate(180deg)"
    } else {
      targetRow.classList.add('hidden')
      this.textTarget.textContent = "View Details"
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }

  // For on-demand loading via Turbo (handles the link click)
  loadDetails(event) {
    // Look for already loaded details row (starts with "transaction_")
    const detailsRow = document.getElementById(this.targetValue.replace('_row_', '_'))
    
    if (detailsRow) {
      // Details already loaded, just toggle visibility
      event.preventDefault()
      const isHidden = detailsRow.classList.contains('hidden')
      
      if (isHidden) {
        detailsRow.classList.remove('hidden')
        this.textTarget.textContent = "Hide Details"
        this.iconTarget.style.transform = "rotate(180deg)"
      } else {
        detailsRow.classList.add('hidden')
        this.textTarget.textContent = "View Details"
        this.iconTarget.style.transform = "rotate(0deg)"
      }
    } else {
      // Details not loaded yet, let the Turbo request proceed
      // The response will render the details and we'll update the UI
      this.textTarget.textContent = "Loading..."
      this.iconTarget.style.transform = "rotate(180deg)"
    }
  }

  connect() {
    // Listen for turbo:stream-render events to update button state
    document.addEventListener("turbo:stream-render", this.handleStreamRender.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:stream-render", this.handleStreamRender.bind(this))
  }

  handleStreamRender(event) {
    // After Turbo stream renders, update the button if it's for our target
    const detailsRow = document.getElementById(this.targetValue.replace('_row_', '_'))
    if (detailsRow) {
      this.textTarget.textContent = "Hide Details"
      this.iconTarget.style.transform = "rotate(180deg)"
    }
  }
}